import {GroupBase, OptionProps, StylesConfig} from "react-select";
import {colors} from "@unibuddy/patron";
import {PATRON_INPUT_HEIGHT} from "../StyleConstants";

type OptionState = OptionProps<unknown, boolean, GroupBase<unknown>>;
type ReactSelectStyles = StylesConfig<unknown, boolean, GroupBase<unknown>>;

function setOptionBackgroundColor(state: OptionState): string {
    if (state.isFocused) {
        return colors.blue500;
    } else if (state.isFocused && state.isSelected) {
        return colors.blue500;
    }
    return "transparent";
}

function setOptionTextColor(state: OptionState): string {
    if (state.isFocused) {
        return "#ffffff";
    }
    return colors.grey900;
}

export function makeReactSelectStyles(propsStyles: ReactSelectStyles): ReactSelectStyles {
    return {
        container: (styles) => ({
            ...styles,
            minHeight: `${PATRON_INPUT_HEIGHT}px`,
        }),
        control: (styles) => ({
            ...styles,
            minHeight: `${PATRON_INPUT_HEIGHT}px`,
        }),
        dropdownIndicator: (styles) => ({
            ...styles,
            color: colors.grey800,
            ":hover": {
                color: colors.grey800,
            },
        }),
        loadingMessage: (styles) => ({
            ...styles,
            color: colors.grey900,
        }),
        multiValue: (styles) => ({
            ...styles,
            backgroundColor: colors.blue600,
        }),
        multiValueLabel: (styles) => ({
            ...styles,
            color: "#ffffff",
        }),
        multiValueRemove: (styles) => ({
            ...styles,
            color: "#ffffff",
        }),
        noOptionsMessage: (styles) => ({
            ...styles,
            color: colors.grey900,
        }),
        option: (styles, state) => ({
            ...styles,
            backgroundColor: setOptionBackgroundColor(state),
            color: setOptionTextColor(state),
        }),
        placeholder: (styles) => ({
            ...styles,
            color: colors.grey900,
        }),
        ...propsStyles,
    };
}
